// Google Map functions for Location Map components

import { styledMap } from "./styled-map";

var initMap = function () {
  const styledMapType = new google.maps.StyledMapType(
    styledMap,
    { name: 'Styled Map' }
  );

  let maps = document.getElementsByClassName('location-map__map');

  for (let i = 0; i < maps.length; i++) {
    const thisMap = maps[i];

    const markerLat = thisMap.getAttribute('data-lat');
    const markerLng = thisMap.getAttribute('data-lng');
    const markerTitle = thisMap.getAttribute('data-title');

    const markerLocation = {lat: parseFloat(markerLat), lng: parseFloat(markerLng)};

    let map = new google.maps.Map(thisMap, {
      center: markerLocation,
      zoom: 15,
      clickableIcons: false,
      disableDefaultUI: true
    });

    let marker = new google.maps.Marker({
      position: markerLocation,
      map: map,
      title: markerTitle
    });

    //Associate the styled map with the MapTypeId and set it to display.
    map.mapTypes.set('styled_map', styledMapType);
    map.setMapTypeId('styled_map');
  }
}

window.initMap = initMap;
